import { render, staticRenderFns } from "./Bag.vue?vue&type=template&id=15f45712&scoped=true&"
import script from "./Bag.vue?vue&type=script&lang=js&"
export * from "./Bag.vue?vue&type=script&lang=js&"
import style0 from "./Bag.scss?vue&type=style&index=0&id=15f45712&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f45712",
  null
  
)

export default component.exports